import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'jquery'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'


new Vue({
	el: '#app',
	router,
  template: '<router-view/>',
  mounted(){
    history.scrollRestoration = "manual";

  }
})



// WEBPACK FOOTER //
// ./src/main.js